import VueRouter from 'vue-router';
import Toasted from 'vue-toasted';
import VeeValidate from 'vee-validate';
import VueLaroute from 'vue-laroute';
// import VueCookie from 'vue-cookie';
import VueMoment from 'vue-moment';
import laroute from './laroute';
import routes from './routes';
import store from './store';
import dictionary from './dictionary/dictionary';
import VuePageTitle from 'vue-page-title';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

/**
 * Bootstrap file and load global
 */
require('./bootstrap');
window.Vue = Vue;
window.laroute = laroute;

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY_VUE,
    plugins: [new BugsnagPluginVue()],
    releaseStage: process.env.NODE_ENV,
    enabledReleaseStages: ['production']
});

Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);

/**
 * Use loaded libraries
 */
Vue.use(VueRouter)

Vue.use(Toasted, {
    'duration': 3000,
    'containerClass': ['top-center', 'font-sans-bold', 'text-black']
})

Vue.use(VeeValidate, {
    useConstraintAttrs: false,
    locale: 'en',
    dictionary: dictionary,
    delay: 275
});

Vue.use(VueMoment);

Vue.use(VueLaroute, {
    laroute,
    accessor: '$laroute', // Optional: the global variable for accessing the router
});

Vue.use(VuePageTitle, {
    prefix: 'Reimagine Collaborator Portal - ',
    // suffix: '- My App '
})

/**
 * Loaded library configs
 */
const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

function isLoggedInStorage() {
    return localStorage.getItem('isLoggedIn');
}

router.beforeEach((to, from, next) => {
    if (to.name === 'contract-via-email' || to.name === 'contract-display') {
        return next(true)
    }

    const isLoggedIn = store.getters.isLoggedIn || isLoggedInStorage() === 'true';

    // if we're heading to an auth page move on
    if (! isLoggedIn && to.path.indexOf('/auth') === -1 && to.path.indexOf('/register') === -1) {
        return next({
            path: '/auth/login'
        });
    }

    const user = store.state.users.user

  if (user.id && !user.isAdmin && to.path.includes('/festivals')) {
    return next({
      path: '/'
    });
  }

    return next(true);
});

router.afterEach((to, from) => {
    if (from.name === 'credit-authorization') {
        document.dispatchEvent(new CustomEvent('destroySquadupEmbed'));
    }
})

import './filters/filters'

import AppRoot from './components/AppRoot.vue';
import {timeAfter, timeBefore} from "./helpers/validation/rules/timeRules";

/**
 * Vue App
 */
new Vue({
    el: '#app-container',
    components: {
        'app-root': AppRoot
    },
    created() {
        this.$validator.extend('upperCase', {
            getMessage: field => `The ${field} must contain one uppercase character`,
            validate: value => value.match(/[A-Z]/g) !== null
        });
        this.$validator.extend('lowerCase', {
            getMessage: field => `The ${field} must contain one lower character`,
            validate: value => value.match(/[a-z]/g) !== null
        });
        this.$validator.extend('number', {
            getMessage: field => `The ${field} must contain one number`,
            validate: value => value.match(/[0-9]/g) !== null
        });

        this.$validator.extend('time_after', timeAfter, { hasTarget: true });
        this.$validator.extend('time_before', timeBefore, { hasTarget: true });

        window.axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response.status === 401 || error.response.status === 419) {
                    this.$toasted.clear();
                    this.$router.push('/auth/login');
                }
                return Promise.reject(error)
            }
        );

    },
    router,
    store,
    methods: {
        getUserOnRefresh() {
            if (this.$store.getters.isLoggedIn) {
                this.$store.dispatch('getMe').then()
            }
        }
    },
    mounted() {
        this.getUserOnRefresh()
    }
});
